import { render, staticRenderFns } from "./left-patient.vue?vue&type=template&id=20a3f6ca&"
import script from "./left-patient.vue?vue&type=script&lang=ts&"
export * from "./left-patient.vue?vue&type=script&lang=ts&"
import style0 from "./left-patient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports